import { IModel } from "maps-angular-components";

export interface CarteiraDTO {
  id: string;
  nomeCNPJ: string;
  nome: string;
}
export class CarteiraCNPJ implements IModel {
  id: string;
  nomeCNPJ: string;
  nome: string;


  constructor(obj?: CarteiraDTO)
  {
    this.id = obj?.id;
    this.nomeCNPJ = obj?.nomeCNPJ;
    this.nome = obj?.nome;
  }

  getId() {
    return this.nome;
  }

  getName() {
    return this.nomeCNPJ;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }
}
